import { render, staticRenderFns } from "./projecttableview.vue?vue&type=template&id=8a280466&"
import script from "./../ts/projecttableview.ts?vue&type=script&lang=js&"
export * from "./../ts/projecttableview.ts?vue&type=script&lang=js&"
import style0 from "./../assets/css/projecttableview.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports